// @react-google-maps/api uses a single global loader singleton. Every
// useJsApiLoader / LoadScript call in the app must pass IDENTICAL options or
// the loader throws "Loader must not be called again with different options".
// Import these shared constants everywhere instead of inlining the config.

// Must be a stable module-level reference so the loader doesn't reload each render.
export const GOOGLE_MAPS_LIBRARIES = ["places"];

// Use the Places-enabled key: it supports both the Maps JavaScript API (map
// rendering) and the Places API (autocomplete/geocoding), so it covers every
// map surface in the panel under one loader.
export const GOOGLE_MAPS_LOADER_OPTIONS = {
  id: "google-map-script",
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_PLACES_API_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
};
